import { NoteStepSchema } from '@feedyou/schema'

import { Search } from '../../../types'
import { createConfigs, searchMutableObject } from '../../../../../features/flowSearch'

export const search: Search<NoteStepSchema> = (step, query) => {
  return searchMutableObject(
    step,
    query,
    { type: 'step', id: step.id },
    createConfigs({
      id: ['id'],
      storage: ['storageSummary.rows.%key%.storage'],
      text: [
        'text',
        'condition',
        'storageSummary.rows.%key%.title',
        'storageSummary.rows.%key%.storage'
      ]
    })
  )
}
